import CloseIcon from '@mui/icons-material/CloseRounded';
import { Button, Tooltip, Typography } from '@mui/material';
import React from 'react';
import QRComponent from 'react-qr-code';

import { useConfig } from '../../hooks/useConfig';
import useModal from '../../hooks/useModal';

function QRCode({
  url,
  size,
  opacity = 1,
  previewJsx = null,
  title = null,
  renderAsTrigger,
}: {
  url: string;
  size: number;
  opacity?: number;
  previewJsx?: JSX.Element;
  title?: string;
  renderAsTrigger?: (onClick: (event: React.MouseEvent) => void) => JSX.Element;
}) {
  const { apiHost } = useConfig();

  const [isHovered, setIsHovered] = React.useState(false);

  // modal needs to be wrapped in a div
  // for centering and padding
  const [showModal, hideModal] = useModal(
    () => {
      const handleQRClick = (event) => {
        if (event.altKey) {
          // Open the QR URL directly with alt click
          window.open(url.replace('adops://', `${apiHost}/`), '_blank');
        }
      };
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '50vh',
            padding: '10px',
          }}
        >
          {/* x icon to close modal in corner */}
          <div style={{ position: 'absolute', right: 0, top: 0 }}>
            <Button variant="text" onClick={hideModal} color="inherit" sx={{ minWidth: 'auto' }}>
              <Tooltip title="Close modal" placement="top-end">
                <CloseIcon fontSize="small" />
              </Tooltip>
            </Button>
          </div>
          <Typography variant="h5">{title}</Typography>
          <br />
          {previewJsx}
          <br />
          <br />
          <QRComponent value={url} style={{ cursor: 'none' }} size={250} onClick={handleQRClick} />
        </div>
      );
    },
    { clickOutsideCloses: true },
    []
  );

  // prevents click from propagating to underlying elements
  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    showModal();
  };

  // Allow custom trigger element (e.g., IconButton) instead of inline QR code
  if (renderAsTrigger) {
    return renderAsTrigger(handleClick);
  }

  return (
    <div style={{ zIndex: 5000 }} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      <QRComponent
        value={url}
        size={size}
        style={{ cursor: 'pointer', opacity: isHovered ? 1 : opacity, paddingBottom: '10px' }}
        role="graphics-document"
        onClick={handleClick}
      />
    </div>
  );
}

export default QRCode;
